import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ClerkProvider } from "@clerk/clerk-react";
import { nlBE } from "@clerk/localizations";

import App from "./App";
import "./styles.css";

const publishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

const root = document.getElementById("root");
if (!root) {
  throw new Error("index.html is missing its #root element.");
}

/**
 * A missing key is a build/config mistake, not a runtime state to design around: fail with a
 * readable message instead of mounting a page whose only feature cannot work.
 */
if (!publishableKey) {
  root.innerHTML =
    '<main class="card"><h1>Configuratie ontbreekt</h1>' +
    "<p>VITE_CLERK_PUBLISHABLE_KEY is niet ingesteld. Zie .env.example.</p></main>";
} else {
  createRoot(root).render(
    <StrictMode>
      {/*
        Clerk's <SignIn /> ships English by default, so without this the one screen a viewer
        actually types into would be the only English thing in the product. nl-BE rather than
        nl-NL: these are Flemish channels (TV Oost, RTV and Ring TV — all .be), and they differ in
        wording, not just spelling.
      */}
      <ClerkProvider publishableKey={publishableKey} localization={nlBE}>
        <App />
      </ClerkProvider>
    </StrictMode>,
  );
}
